import React, {Fragment} from 'react'
import { urlFor } from "../../../lib/client";
import Image from 'next/image';

const HeroSection = ({data}) => {

  return (
    <Fragment>
            <section
        className="page-banner pt-210 rpt-150 pb-75 rel z-1"
        style={{ backgroundImage: "url(/assets/images/hero/hero-two-bg.png)" }}
      >
        <div className="container container-1290">
          <div className="row">
            <div className="col-lg-12">
              <h1 className="hero-title style-two mt-65 mb-30 wow fadeInUp delay-0-2s">
                {data.PFS_Heading}
                <Image
                width={128}
                height={126}
                layout='responsive'
                  className="mxw-10 leaf"
                  src={urlFor(data.vector_image).url()}
                  alt={data.vector_image.alt}
                />
              </h1>
              <div className="banner-text wow fadeInUp delay-0-3s">
              {data.PFS_Paragraph}
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="project-details-image rel z-1">
        <div className="container-fluid">
          <div className="image wow fadeInUp delay-0-2s">
            <Image
            width={1277}
            height={718}
              src={urlFor(data.hero_image).url()}
              alt={data.hero_image.alt}
              layout='responsive'
            />
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default HeroSection